import { CASE_STUDIES, WA_MESSAGES, waLink } from "./data";
import { ArrowCta, Eyebrow, MaskLines, Reveal } from "./ui-bits";

const CaseStudies = () => (
  <section id="cases" className="bg-ivory text-obsidian" data-testid="cases-section">
    <div className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-36">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <Eyebrow tone="dark">05 / Selected Engagements</Eyebrow>
          <h2 className="mt-6 font-serif text-4xl leading-[1.02] sm:text-5xl lg:text-6xl">
            <MaskLines lines={["THE WORK", "SPEAKS."]} />
          </h2>
        </div>
        <p className="max-w-xs text-[11px] italic leading-relaxed tracking-[0.04em] text-obsidian/45">
          Representative of typical Elevate mandates. Client details shared on
          request.
        </p>
      </div>

      <div className="mt-16 grid gap-10 md:grid-cols-3 md:gap-8">
        {CASE_STUDIES.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.1}>
            <article className="group" data-testid={`case-study-${c.n}`}>
              <div className="relative h-64 overflow-hidden" data-cursor="view">
                <img
                  src={c.img}
                  alt={c.title}
                  className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]"
                />
                <span className="absolute left-4 top-4 bg-obsidian/80 px-3 py-1.5 text-[10px] font-medium uppercase tracking-[0.24em] text-champagne backdrop-blur-sm">
                  Case Study / {c.n}
                </span>
              </div>
              <div className="mt-5 text-[11px] font-medium uppercase tracking-[0.24em] text-champagne">
                {c.cat}
              </div>
              <h3 className="mt-3 font-serif text-2xl leading-snug">{c.title}</h3>
              <div className="mt-6 grid grid-cols-2 gap-x-4 gap-y-4 border-t border-obsidian/15 pt-5">
                {Object.entries(c.meta).map(([k, v]) => (
                  <div key={k}>
                    <div className="text-[9px] font-medium uppercase tracking-[0.24em] text-obsidian/45">
                      {k}
                    </div>
                    <div className="mt-1 text-sm">{v}</div>
                  </div>
                ))}
              </div>
              <div className="mt-6">
                <ArrowCta dark href={waLink(WA_MESSAGES.cases)} testId={`case-study-cta-${c.n}`}>
                  View Case Study
                </ArrowCta>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default CaseStudies;
